module.exports = require("./JobConfigPicker.vue");